import { render, staticRenderFns } from "./GroupMembersTransferDialog.vue?vue&type=template&id=b21ff572&scoped=true&"
import script from "./GroupMembersTransferDialog.vue?vue&type=script&lang=ts&"
export * from "./GroupMembersTransferDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21ff572",
  null
  
)

export default component.exports